if (!window.customElements.get('hamper-package-expand')) {
  window.customElements.define(
    'hamper-package-expand',
    class extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.hamperPackage = this.closest('.hamper-package');
        this.textContainer = this.querySelector('span');
        this.addEventListener('click', this.toggleExpand);
        this.textContainer.textContent = this.dataset.expandText;
      }

      toggleExpand() {
        if (this.dataset.expanded === 'true') {
          this.hideHiddenElements(this.hamperPackage.querySelectorAll('.hamper-columns-wrapper:not(:first-child)'));
          this.hideHiddenElements(
            this.hamperPackage.querySelectorAll(
              '.hamper-columns-wrapper:first-child .hamper-columns__column:nth-child(n+3)'
            )
          );
        } else {
          this.showHiddenElements(this.hamperPackage.querySelectorAll('.hamper-columns-wrapper.hidden'));
          this.showHiddenElements(this.hamperPackage.querySelectorAll('.hamper-columns__column.hidden'));
        }
      }

      showHiddenElements(elements) {
        elements.forEach((wrapper) => {
          wrapper.classList.remove('hidden');
        });
        this.dataset.expanded = 'true';
        this.textContainer.textContent = this.dataset.collapseText;
      }

      hideHiddenElements(elements) {
        elements.forEach((wrapper) => {
          wrapper.classList.add('hidden');
        });
        this.dataset.expanded = 'false';
        this.textContainer.textContent = this.dataset.expandText;
      }
    }
  );
}
